import { render, staticRenderFns } from "./RedpacketDelay.vue?vue&type=template&id=169c7128&"
import script from "./RedpacketDelay.vue?vue&type=script&lang=js&"
export * from "./RedpacketDelay.vue?vue&type=script&lang=js&"
import style0 from "./RedpacketDelay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports